














import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import MypageFavoritePlayerInitSelectPane from '@/components/MypageFavoritePlayerInitSelectPage/MypageFavoritePlayerInitSelectPane.vue'

export type DataType = {
  screenTransitionModal: boolean
  screenTransitionTo: string
}

/**
 * マイページ: お気に入り選手選択ページ
 */
export default defineComponent({
  name: 'MypageFavoritePlayerInitSelectPage',
  components: {
    SubHeaderSection,
    MypageFavoritePlayerInitSelectPane,
  },
  data(): DataType {
    return {
      screenTransitionModal: false, // 画面遷移警告モーダル表示フラグ
      screenTransitionTo: '', // 画面遷移警告モーダル 遷移先指定
    }
  },
  methods: {
    /**
     * 会員情報入力ページに遷移する
     */
    moveToMypageUserInit(): void {
      this.$router.replace({ name: 'MypageUserInitPage' })
    },
  },
})
